import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const getAuthConfig = () => {
  const token = localStorage.getItem('token');
  return {
    headers: { Authorization: `Bearer ${token}` }
  };
};

const normalizeUser = (user) => ({
  id: user.id,
  email: user.email || '',
  status: (user.status || 0),
  created_at: user.created_at || user.createdAt || null,
  updated_at: user.updated_at || user.updatedAt || null
});

const shouldTryNextEndpoint = (error) => {
  const status = error?.response?.status;
  return status === 404 || status === 405;
};

const requestWithFallback = async (method, endpoints, data) => {
  let lastError;
  console.log(data,"pirnthe data")

  for (const endpoint of endpoints) {
    try {
      const response = await axios({
        method,
        url: `${API_URL}${endpoint}`,
        data,
        ...getAuthConfig()
      });
      return response.data;
    } catch (error) {
      lastError = error;
      if (!shouldTryNextEndpoint(error)) {
        throw error;
      }
    }
  }

  throw lastError || new Error('No API endpoint available for this action.');
};

export const fetchAdminUsers = async () => {
  const data = await requestWithFallback('get', [
    '/admin/users'
  ]);

  const users = Array.isArray(data) ? data : (data.users || data.data || []);
  return users.map(normalizeUser);
};

export const fetchAdminUserById = async (id) => {
  try {
    const user = await requestWithFallback('get', [
      `/admin/users/${id}`
    ]);
    return normalizeUser(user.user || user.data || user);
  } catch (error) {
    if (shouldTryNextEndpoint(error) || error?.response?.status === 400) {
      const users = await fetchAdminUsers();
      const found = users.find((item) => String(item.id) === String(id));
      if (found) return found;
    }
    throw error;
  }
};

export const createAdminUser = async (payload) => {
  return requestWithFallback('post', [
    '/admin/users',
  ], {
    ...payload,
    role: payload.role || 'admin'
  });
};

export const updateAdminUser = async (id, payload) => {
  const endpoints = [
    `/admin/users/${id}`
  ];

  try {
    return await requestWithFallback('put', endpoints, payload);
  } catch (error) {
    if (error?.response?.status !== 404 && error?.response?.status !== 405) {
      throw error;
    }
  }

  return requestWithFallback('patch', endpoints, payload);
};
